import {
  screenerAPI
} from '../../hooks/api';

import { client } from '../../services/screener-service';
import getScreenerArgs from '../screener/actions/screener-args';

const getTagsByXid = async (yyy, channel, xid) => {
  const xidArgs = { TCWSODIssue: [{ operator: 'Like', values: [xid || -1] }] };
  const screenerArgs = getScreenerArgs(xidArgs);
  let result = { items: [] };
  try {
    const service = await client(yyy, channel);
    const inputs = {
      client: service,
      screenId: 329,
      params: screenerArgs
    };
    const response = await screenerAPI(inputs);
    result = response;
  } catch (error) {
    console.log(error.errorMsg);
  }
  return result;
};

export default getTagsByXid;
